import React, { useEffect } from "react";
import "./home.css";
import HeaderSocials from "./HeaderSocials";
import ScrollDown from "./ScrollDown";
import Shapes from "./Shapes";
import SimpleOptimizedImage from "../common/SimpleOptimizedImage";

const Home = () => {
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-7R8LLSWJ8K";
    script1.async = true;

    const script2 = document.createElement("script");
    script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-7R8LLSWJ8K');
        `;

    document.head.appendChild(script1);
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return (
    <section className="home container" id="home">
      <div className="intro">
        <SimpleOptimizedImage 
          src="/images/PFP.webp" 
          alt="Ivan Tsang - Software Engineer" 
          className="home__img"
        />
        <h1 className="home__name">Ivan Tsang</h1>
        <span className="home__title">Software Engineer</span>

        <HeaderSocials />

        {/* <a href="#contact" className="btn">
          Contact Me
        </a> */}

        <ScrollDown />
      </div>

      <Shapes />
    </section>
  );
};

export default Home;
